import React from 'react';
import { IconArrowRight, IconBack, useDirection } from '@adc/parallax-component-library';
const TopHeaderBackArrow = ({ testID }) => {
    return useDirection() === 'ltr' ? (React.createElement(IconBack, { color: "$neutral.100", testID: testID })) : (React.createElement(IconArrowRight, { color: "$neutral.100", testID: testID }));
};
export { TopHeaderBackArrow };
